import React from "react";

interface ImgixImg {
  src: string;
  imgixParams: {
    w: number;
    h?: number;
    fit?: string;
    crop?: string;
    q?: number;
  };
}

const ImgixImg: React.FC<ImgixImg> = ({ src, imgixParams }) => {
  const newSrc = `${src}?auto=format,compress${
    imgixParams.q ? "&q=" + imgixParams.q : "&q=80"
  }${imgixParams.fit ? "&fit=" + imgixParams.fit : ""}${
    imgixParams.crop ? "&crop=" + imgixParams.crop : ""
  }${imgixParams.w ? "&w=" + imgixParams.w : ""}${
    imgixParams.h ? "&h=" + imgixParams.h : ""
  }`;

  const newSrcSet = newSrc + "&dpr=1 1x, " + newSrc + "&dpr=2 2x";

  return <img src={newSrc} srcSet={newSrcSet} alt="" />;
};

export default ImgixImg;
